<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="mb-0">Modul & Pelajaran</h6>
      <button type="button" class="btn btn-sm btn-outline-primary" @click="addModule">
        <i class="fas fa-plus"></i> Tambah Modul
      </button>
    </div>

    <div v-for="(mod, mi) in localModules" :key="mi" class="border rounded p-3 mb-3 bg-light">
      <div class="d-flex align-items-center mb-2" style="gap:8px;">
        <span class="badge badge-secondary">{{ mi + 1 }}</span>
        <input v-model="mod.title" class="form-control form-control-sm" placeholder="Judul modul">
        <button type="button" class="btn btn-sm btn-outline-danger" @click="removeModule(mi)"><i class="fas fa-trash"></i></button>
      </div>

      <div v-for="(lesson, li) in mod.lessons" :key="li" class="border rounded p-2 mb-2 bg-white">
        <div class="row">
          <div class="col-md-6 mb-1">
            <input v-model="lesson.title" class="form-control form-control-sm" placeholder="Judul pelajaran">
          </div>
          <div class="col-md-3 mb-1">
            <select v-model="lesson.content_type" class="form-control form-control-sm">
              <option value="text">Teks / HTML</option>
              <option value="video">Video URL</option>
              <option value="pdf">PDF / File URL</option>
              <option value="quiz">Quiz (placeholder)</option>
            </select>
          </div>
          <div class="col-md-2 mb-1">
            <input v-model.number="lesson.duration_minutes" type="number" min="0" class="form-control form-control-sm" placeholder="Menit">
          </div>
          <div class="col-md-1 mb-1">
            <button type="button" class="btn btn-sm btn-outline-danger w-100" @click="removeLesson(mi, li)"><i class="fas fa-times"></i></button>
          </div>
        </div>
        <div v-if="lesson.content_type === 'video'" class="mt-1">
          <input v-model="lesson.video_url" class="form-control form-control-sm" placeholder="URL video (YouTube embed, Vimeo, dll)">
        </div>
        <div v-else-if="lesson.content_type !== 'quiz'" class="mt-1">
          <textarea v-model="lesson.content" class="form-control form-control-sm" rows="2" placeholder="Konten pelajaran (HTML/text) atau URL file"></textarea>
        </div>
        <div v-else class="mt-1">
          <small class="text-muted">Quiz — fitur quiz lengkap coming soon. Siswa akan melihat placeholder.</small>
        </div>
        <div class="form-check mt-1">
          <input :id="'preview_' + mi + '_' + li" type="checkbox" class="form-check-input" v-model="lesson.is_preview">
          <label :for="'preview_' + mi + '_' + li" class="form-check-label small">Preview gratis (bisa dilihat tanpa bayar)</label>
        </div>
      </div>

      <button type="button" class="btn btn-sm btn-link" @click="addLesson(mi)">
        <i class="fas fa-plus"></i> Tambah Pelajaran
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModuleLessonEditor',
  props: { value: { type: Array, default: () => [] } },
  computed: {
    localModules: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); },
    },
  },
  methods: {
    addModule() {
      this.localModules = [...this.localModules, { title: 'Modul Baru', lessons: [{ title: 'Pelajaran 1', content_type: 'text', content: '', is_preview: false }] }];
    },
    removeModule(mi) {
      const m = [...this.localModules];
      m.splice(mi, 1);
      this.localModules = m;
    },
    addLesson(mi) {
      const m = [...this.localModules];
      m[mi].lessons.push({ title: 'Pelajaran Baru', content_type: 'text', content: '', is_preview: false });
      this.localModules = m;
    },
    removeLesson(mi, li) {
      const m = [...this.localModules];
      m[mi].lessons.splice(li, 1);
      this.localModules = m;
    },
  },
};
</script>
